import Support from './Support'

export default Support
